import { Coord } from "../../types/Interface";
import getAngleBetweenPoints from "./getAngleBtwPoints";

export default function calcAngles(cCoord: Coord, coordStart: Coord, coordEnd: Coord) {
  const startRadian = getAngleBetweenPoints(cCoord, coordStart);
  const endRadian = getAngleBetweenPoints(cCoord, coordEnd);
  return { startRadian, endRadian }
}